export const productDiscountedPriceFunc = (productData, sellingPriceKey) => {
  // Discount price and text - Product
  // Variables

  let discountedPrice = false;
  let discountPercentageText = "";

  let productMrpPrice = parseFloat(productData.mrp || "0");
  let productSellingPrice = parseFloat(productData[sellingPriceKey] || "0");

  // Determine if the product is discounted
  if (productMrpPrice === productSellingPrice) {
    discountedPrice = false;
  } else {
    discountedPrice = true;
  }

  // Calculate discount percentage and set discount text
  let discountPercentage = parseFloat(
    (productSellingPrice * 100) / productMrpPrice
  );

  discountPercentageText =
    discountPercentage && !isNaN(discountPercentage)
      ? (discountPercentageText =
          (100 - discountPercentage).toFixed(2) + " % off")
      : "";

  return discountedPrice;
};

// For variant product
export const DiscountedPriceForVariantFunc = (productData, varientIndex) => {
  let discountedPrice = false;

  if (productData?.productVarient?.length > 0) {
    if (
      parseFloat(productData.productVarient[varientIndex]?.mrp) ===
      parseFloat(productData.productVarient[varientIndex]?.sellingprice)
    ) {
      discountedPrice = false;
    } else {
      discountedPrice = true;
    }
  }

  return discountedPrice;
};
